/**
 * Microsoft Clarity custom events for the AI-Ready Check.
 *
 * Clarity arrives through GTM a moment after the page, but the first card is
 * on screen before that. So when `window.clarity` is not there yet we install
 * the same queue stub as Clarity's own snippet; that snippet keeps an existing
 * stub (`c[a] = c[a] || …`) and replays its queue once loaded, so nothing fired
 * early is lost. Like the rest of the check's tracking, this never throws.
 */

// eslint-disable-next-line no-unused-vars
type ClarityFn = ((...args: unknown[]) => void) & { q?: unknown[][] };

function clarity(...args: unknown[]) {
  if (typeof window === "undefined") return;
  try {
    const w = window as unknown as { clarity?: ClarityFn };
    if (typeof w.clarity !== "function") {
      const stub: ClarityFn = (...a: unknown[]) => {
        (stub.q = stub.q || []).push(a);
      };
      w.clarity = stub;
    }
    w.clarity(...args);
  } catch {
    /* tracking is never worth breaking the page */
  }
}

/** A named moment, e.g. `quiz_card_5`. Shows under Custom events in Clarity. */
export function clarityEvent(name: string) {
  clarity("event", name);
}

/** A session label to filter recordings by. Shows under Custom tags in Clarity. */
export function clarityTag(key: string, value: string) {
  clarity("set", key, value);
}
